@if (_context) {
    <mat-tab-group class="detail-tabs">
        <mat-tab label="Infos">
            <app-email-template-form
                [disabled]="_context.formMode === FormMode.Reading"
                [context]="_context.formContext"
                [emailTemplate]="_context.formContext.item"
                (emailTemplateUpdated)="onEmailTemplateUpdated($event)"
                (canceled)="onCanceled($event)"></app-email-template-form>
        </mat-tab>
    </mat-tab-group>
}
